import { render, staticRenderFns } from "./WheelsToggle.vue?vue&type=template&id=75a74a0c&scoped=true"
import script from "./WheelsToggle.vue?vue&type=script&setup=true&lang=ts"
export * from "./WheelsToggle.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WheelsToggle.vue?vue&type=style&index=0&id=75a74a0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a74a0c",
  null
  
)

export default component.exports